export default __webpack_public_path__ + "static/media/WhatsApp_Image_2021-03-22_at_1.17.13_PM-removebg.1e566554.png";